import { ISandboxProps } from "./interface"
import { SAFE_GLOBALS } from "../utils/safe-globals"

export const defaultProps: ISandboxProps = {
    globals: SAFE_GLOBALS
}
